import { Family } from "@joonapp/web-shared"
import { captureException } from "@sentry/react"

import { createJoonAPIClient } from "../../util/joon-api"

export const loadFamily = async (id: number) => {
  const API = createJoonAPIClient()
  try {
    const response = await API.get<Family>(`api/families/${id}/`)
    return response.data
  } catch (error) {
    captureException(error)
    throw error
  }
}
